import { loadPerfil } from '../helpers/perfil';

const PERFIL_LOADED = '[PERFIL LD] PERFIL LOADED'
const PERFIL_UPDATE_PHOTO = '[PERFIL U P] PERFIL UPDATE PHOTO'
const PERFIL_UPDATE_DESCRIPTION = '[PERFIL UP D] PERFIL UPDATE DESCRIPTION'
const PERFIL_UPDATE_GENDER = '[PERFIL UP G] PERFIL UPDATE GENDER'
const PERFIL_UPDATE_FACULTAD = '[PERFIL UP F] PERFIL UPDATE FACULTAD'

const PERFIL_UPDATE_DISPLAYNAME = '[PERFIL UP D] PERFIL UPDATE DISPLAY'
const PERFIL_UPDATE_ASIGNATURAS = '[PERFIL UP D] PERFIL UPDATE ASIGNATURAS'
const PERFIL_UPDATE_PROGRAMA = '[PERFIL UP D] PERFIL UPDATE PROGRAMA'

const PERFIL_LOGOUT = '[PL] PERFIL LOGOUT'

export const startLoadingPerfil = (puid) => {
    return async (dispatch) => {
        const perfil = await loadPerfil(puid);
        const {uid, email, rol, state, displayName, photoURL, faculty,program, subjects,description, gender} = perfil[0];

        dispatch(setPerfil(uid, email, rol, state, displayName, photoURL, faculty,program, subjects,description, gender))
    }
}

const setPerfil = (uid, email, rol, state, displayName, photoURL, faculty,program, subjects,description,gender) => ({
    type: PERFIL_LOADED,
    payload: {
        uid, email, rol, state, displayName, photoURL, faculty, program, subjects,description,gender
    }
})


export const updatePhotoPerfil = (url) => ({
    type: PERFIL_UPDATE_PHOTO,
    payload: {
        url
    }
})


export const setPerfilDescription = (description) => ({
    type: PERFIL_UPDATE_DESCRIPTION,
    payload:{
        description
    }
})


export const setPerfilGender = (gender) => ({
    type: PERFIL_UPDATE_GENDER,
    payload:{
        gender
    }
})


export const setPerfilFacultad = (faculty) => ({
    type: PERFIL_UPDATE_FACULTAD,
    payload:{
        faculty
    }
})

export const setPerfilDisplayName = (displayName) => ({
    type: PERFIL_UPDATE_DISPLAYNAME,
    payload:{
        displayName
    }
})

export const setPerfilAsignaturas = (subjects) => ({
    type: PERFIL_UPDATE_ASIGNATURAS,
    payload:{
        subjects
    }
})

export const setPerfilPrograma = (program) => ({
    type: PERFIL_UPDATE_PROGRAMA,
    payload:{
        program
    }
})


export const logoutPerfil = () => ({
    type: PERFIL_LOGOUT
})

const PerfilReducer = (state = {}, action ) => {
    switch (action.type) {
        case PERFIL_LOADED:
            return {
                uid: action.payload.uid,
                displayName: action.payload.displayName,
                state: action.payload.state,
                email: action.payload.email,
                photoURL: action.payload.photoURL,
                faculty: action.payload.faculty,
                program: action.payload.program,
                subjects: action.payload.subjects,
                rol: action.payload.rol,
                description: action.payload.description,
                gender: action.payload.gender
        }
        case PERFIL_UPDATE_PHOTO:
            return {
                ...state,
                photoURL: action.payload.url
            }
        case PERFIL_UPDATE_DESCRIPTION:
            return {
                ...state,
                description: action.payload.description
            }
        case PERFIL_UPDATE_GENDER:
            return {
                ...state,
                gender: action.payload.gender
            }
        case PERFIL_UPDATE_FACULTAD:
            return {
                ...state,
                faculty: action.payload.faculty
            }
        case PERFIL_UPDATE_DISPLAYNAME:
            return {
                ...state,
                displayName: action.payload.displayName
            }
        case PERFIL_UPDATE_ASIGNATURAS:
            return {
                ...state,
                subjects: action.payload.subjects
            }
        case PERFIL_UPDATE_PROGRAMA:
            return {
                ...state,
                program: action.payload.program
            }
        case PERFIL_LOGOUT:
            return {}
        default:
            return state
    }
}

export default PerfilReducer;